export const BU_MESSAGE_COLORS = [
  'white',
  'light',
  'dark',
  'black',
  'text',
  'primary',
  'link',
  'info',
  'success',
  'warning',
  'danger'
];

export const BU_MESSAGE_SIZES = [
  'small',
  'medium',
  'large'
];
